const loadResource = (lang) => ({
  [lang]: {
    'react-dapp-framework': require(`./${lang}/react-dapp-framework.json`),
  },
});

module.exports = {
  loadResource,
};
